export default __webpack_public_path__ + "static/media/right-square.e2a9664a.svg";